export enum ChatState {
  Loading = "loading",
  Normal = "normal",
  Participants = "participants"
}
